export default __webpack_public_path__ + "static/media/arrow_right_ckb.5db81021.svg";